import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

/**
 * 定义 Past 组件
 */
class Past extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <div className={styles.past}>
                <div>
                    <h2 className={styles.pastH}>
                        <b>往期推荐</b>
                    </h2>
                    <div className={styles.passItem}>
                        <ul>
                            {content.map((item, index) => (
                                <li key={index}>
                                    <a href={item.url} target="_blank">
                                        <img src={item.thumbnail} width="120" height="76" alt={item.title} />
                                    </a>
                                    <h3>
                                        <a href={item.url} target="_blank">
                                            {item.title}
                                        </a>
                                    </h3>
                                    <p>{item.newsTime}</p>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Past);
